<div class="navbar">
  <mat-accordion multi displayMode="flat" togglePosition="before">
    <mat-expansion-panel expanded *ngFor="let link of links">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ link.title }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-list role="list" dense>
        <a
          class="link"
          mat-list-item
          *ngFor="let sublink of link.sublinks"
          skipLocationChange="true"
          (click)="scrollToElementById($event, sublink.title)"
        >
          <mat-icon class="fail" color="warn" *ngIf="!sublink.isPassed"
            >priority_high</mat-icon
          >
          <span>{{ sublink.title }}</span>
        </a>
        <!-- <a
          class="link"
          mat-list-item
          *ngFor="let sublink of link.sublinks"
          [routerLink]="'.'"
          fragment="{{ sublink.title }}"
          skipLocationChange="true"
          (click)="scrollToElementById($event, sublink.title)"
        >
          <mat-icon class="fail" color="warn" *ngIf="!sublink.isPassed"
            >priority_high</mat-icon
          >
          <span>{{ sublink.title }}</span>
        </a> -->
      </mat-list>
    </mat-expansion-panel>
  </mat-accordion>
</div>
